const emptyQuestion = {
	type: "text",
	question: "",
};

export default emptyQuestion;
